import Vue from 'vue';
import VueTelInputVuetify from 'vue-tel-input-vuetify';
import 'crypto-js/lib-typedarrays';
import Amplify, { Auth } from 'aws-amplify';

import { init as initErrorHandler } from '@/utils/error';
initErrorHandler();

import App from './App';
import router from './router';
import vuetify from './plugins/vuetify.plugin';
import config from './aws-exports';
import { Tracking } from './utils/tracking';
import store from './plugins/store.plugin';

Tracking.init();

Amplify.configure(config);

const { VUE_APP_IDENTITY_POOL_ID, VUE_APP_USER_POOL_ID, VUE_APP_USER_POOL_WEB_CLIENT_ID, VUE_APP_DOMAIN } = process.env;

const identityPoolId = VUE_APP_IDENTITY_POOL_ID;
const userPoolId = VUE_APP_USER_POOL_ID;
const userPoolWebClientId = VUE_APP_USER_POOL_WEB_CLIENT_ID;

let domain = VUE_APP_DOMAIN;

Amplify.configure({
	Auth: {
		identityPoolId,
		region: 'eu-west-1',
		userPoolId,
		userPoolWebClientId,
		mandatorySignIn: false,
		cookieStorage: {
			domain,
			expires: 365,
			secure: false,
		},
		// OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
		//authenticationFlowType: 'USER_SRP_AUTH',
		oauth: {},
	},
});

Vue.use(Auth);
Vue.use(VueTelInputVuetify, {
	vuetify,
});

Vue.config.productionTip = false;

const initApp = async () => {
	let params = new URL(document.location).searchParams;
	let tenantId = params.get('tid');
	if (!tenantId) {
		tenantId = process.env.VUE_APP_DEFAULT_TENANT_ID;
	}

	//Set tenant settings
	const tenant = await store.dispatch('tenant/LoadTenant', tenantId);
	tenant.settings.set(vuetify);
};

initApp().then(() => {
	new Vue({
		el: '#app',
		store,
		vuetify,
		render: h => h(App),
		router,
	});
});
